import React from 'react'
import { Button, Form, Modal } from 'react-bootstrap'

const UpdateCaseNumbrModal = ({
    showUpdateCaseNumberModal,
    setShowUpdateCaseNumberModal,
    setCaseNumber,
    caseNumber,
    setCaseDate,          // 👈 new state setter for date
    caseDate,             // 👈 date value
    submitCaseNumberUpdate,
    caseNumberLoading
}) => {
    return (
        <div>
            <Modal
                show={showUpdateCaseNumberModal}
                onHide={() => setShowUpdateCaseNumberModal(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update E-Filing / Case Number</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>E-Filing / Case Number *</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter case number"
                                value={caseNumber}
                                onChange={(e) => setCaseNumber(e.target.value)}
                            />
                        </Form.Group>

                        {/* ---------------- Date Input ---------------- */}
                        <Form.Group className="mb-3">
                            <Form.Label>Case Date *</Form.Label>
                            <Form.Control
                                type="date"
                                value={caseDate}
                                onChange={(e) => setCaseDate(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowUpdateCaseNumberModal(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={submitCaseNumberUpdate}
                        disabled={caseNumberLoading}
                    >
                        {caseNumberLoading ? 'Updating...' : 'Update Case Number'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default UpdateCaseNumbrModal
